define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.listItem = function () {
        return {
            restrict: 'E',
            replace: true,
            template:
            '<div class="met-list">' +
            '   <div class="met-list-item" data-id="id">' +
            '       <div class="item-clock pull-left" ng-show="model.locked">' +
            '           <div class="item-inner">' +
            '               <i class="fa fa-clock-o fa-lg"></i>' +
            '           </div>' +
            '       </div>' +
            '       <div class="item-checkbox pull-left" ng-show="model.unassigned && !model.locked">' +
            '           <div class="item-inner">' +
            '               <met-checkbox data-checked="markedForDeletion"></met-checkbox>' +
            '           </div>' +
            '       </div>' +
            '       <div class="item-content">' +
            '           <div class="item-inner">' +
            '               <h3><a ng-show="!model.locked" href ng-click="model.linkAction(model.id)">{{model.label}}</a><span ng-show="model.locked">{{model.label}}</span></h3>' +
            '               <p>{{model.description}}</p>' +
            '           </div>' +
            '       </div>' +
            '       <div class="item-view pull-right" ng-show="model.showView">' +
            '           <div class="item-inner">' +
            '               <a ng-click="model.viewAction(model.id)" class="fa fa-eye fa-lg"></a>' +
            '           </div>' +
            '       </div>' +
            '   </div>' +
            '</div>'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/listItem.js